import React, { Component } from 'react';
import ImageGallery, { FlowShot } from '../Imgpop';
import FeatureCards from '../FeatureCards';
import TechTags from '../TechTags';
import "./style.css"

class LegacyPostWizard extends Component {
    render() {
        const wizardFlow = [
            {
                src: require('./img/react-post-wizard/post_wizard_1.png'),
                title: 'Choose content type',
                alt: 'Choose content type step with Communications, General, and Featured options',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
            {
                src: require('./img/react-post-wizard/post_wizard_2.png'),
                title: 'Choose communications subtype',
                alt: 'Choose subtype step with Daily Admin selected for Communications',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
            {
                src: require('./img/react-post-wizard/post_wizard_3.png'),
                title: 'Choose contact (if any) and audience',
                alt: 'Choose audience step with contact names and campus locations',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
            {
                src: require('./img/react-post-wizard/post_wizard_4.png'),
                title: 'Build the post',
                alt: 'Post editor with audience, locations, and topics in the sidebar',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
            {
                src: require('./img/react-post-wizard/post_wizard_5.png'),
                title: 'Schedule or save',
                alt: 'Save options with Schedule selected and a publication date calendar',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
            {
                src: require('./img/react-post-wizard/post_wizard_6.png'),
                title: 'Review and submit',
                alt: 'Ready to submit review with destination, audience, and schedule details',
                variant: 'screenshot',
                className: 'screenshot-view',
            },
        ];

        const approvalShot = {
            src: require('./img/react-post-wizard/post-authors.png'),
            title: 'Assign approvers by content area',
            alt: 'Approval assignments by content area, including Admin Hub, Compliance Hub, and General',
            variant: 'screenshot',
            className: 'screenshot-view',
        };

        const galleryImages = [...wizardFlow, approvalShot];

        const relatedProjects = [
            {
                id: 'legacy-link',
                title: 'Legacy Link Intranet Platform',
                description: 'Explore the larger personalized employee platform that supports this application’s authentication, permissions, audience targeting, and organizational data.',
                cta: 'View the Legacy Link case study →',
            },
        ];

        const highlightCards = [
            {
                title: 'Permission-Aware Options',
                description: 'Users see only the content areas and publishing options available to them based on their assigned capabilities. Audience controls are personalized using the user’s location and employee-group taxonomy assignments, limiting available campuses and employee groups to those the user is authorized to target.',
            },
            {
                title: 'Personalized Defaults',
                description: 'Campus locations, employee groups, and related settings are automatically preselected using the user’s profile and organizational role.',
            },
            {
                title: 'Guided Post Review',
                description: 'The wizard evaluates required fields and clearly identifies what is complete and what still needs attention.',
            },
        ];

        return (
            <div className='collapsible'>
                <h1>React Post Wizard</h1>
                <div className="gradient"></div>
                <p className='eyebrow mt-4'>A guided, personalized, and permission-aware publishing experience</p>
                <div className="details">
                    <p>The React Post Wizard is a custom publishing workflow that guides content creators through building, targeting, and reviewing their posts. Based on each user’s permissions, it displays only the publishing destinations they are authorized to use, such as Daily Admin, Legacy News, and other specialized content areas.</p>
                    <p>The experience is personalized using the user’s campus, organizational role, and publishing capabilities. Relevant locations, employee groups, and other settings are automatically preselected whenever possible, reducing repetitive work and helping content reach the correct audience.</p>
                    <FeatureCards className="mt-4 mb-4" items={highlightCards} />
                    <p className='eyebrow mt-4'>Guided Authoring Experience</p>
                    <ImageGallery images={galleryImages}>
                        <div className="wizard-flow">
                            {wizardFlow.map((step, index) => (
                                <FlowShot
                                    key={step.title}
                                    {...step}
                                    step={index + 1}
                                    index={index}
                                />
                            ))}
                        </div>
                        <div className="feature-card">
                    <p className='eyebrow mt-4'>Flexible Publishing and Approval Workflows</p>
                    <p>I extended WordPress’s native authoring and publishing workflow with a custom approval-routing system. Authors continue to use the familiar WordPress process to create and submit content, while the custom functionality determines who should review it based on the selected Content Location.</p>
                    <p>I also built an administrative dashboard within WordPress where site administrators can assign specific individuals or groups as approvers for each Content Location, along with a default approval group when no specific assignment exists.</p>
                    <p>When an author without publishing permissions submits a post, WordPress’s native pending-review status is used. My custom workflow identifies the appropriate approvers, sends them an email with a direct link to the post, and provides options to publish or request changes. Requested changes return the post to the author with feedback displayed directly in the editor.</p>
                    <p>This approach builds on WordPress’s existing roles, permissions, and publishing states while adding configurable approval routing and notifications tailored to the organization’s content structure.</p>
                    <FlowShot
                        {...approvalShot}
                        index={wizardFlow.length}
                        layout="single"
                    />
                    </div>
                    </ImageGallery>
                    <TechTags
                        items={['React', 'JavaScript/JSX', 'PHP', 'CSS', 'WordPress Block Editor APIs', 'Roles & capabilities', 'User metadata', 'Taxonomies', 'WordPress data stores']}
                    />
                    <p className="eyebrow mt-4">Related Projects</p>
                    <FeatureCards className="mt-4 mb-4" items={relatedProjects} onNavigate={this.props.onNavigate} />
                </div>
            </div>
        )
    }
}

export default LegacyPostWizard;